<span class="notice-message" role="status">
  @if (versions.newVersionAvailable()) {
  {{ 'newVersion.message' | translate }}
  }
</span>
@if (versions.newVersionAvailable()) {
<dx-button
  type="normal"
  stylingMode="contained"
  icon="refresh"
  [text]="'newVersion.reload' | translate"
  [disabled]="reload.locked()"
  (onClick)="reload.reloadNow()"
></dx-button>
}
